/**
 * Shared date formatting utilities
 * Issue #108: Consistent timestamp display across marketplace components
 */

/**
 * Format a timestamp as relative time (e.g., "5 Min.", "2 Std.", "3 Tage")
 * Falls back to absolute date for timestamps older than 7 days
 *
 * @param {string|Date} timestamp - ISO timestamp or Date object
 * @param {function} t - Translation function from useLanguage hook
 * @returns {string} Formatted relative time string
 */
export const formatRelativeTime = (timestamp, t) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  // Show relative time for recent timestamps
  if (diffMins < 1) {
    return t('notifications.justNow');
  } else if (diffMins < 60) {
    return `${diffMins} ${t('notifications.minutesAgo')}`;
  } else if (diffHours < 24) {
    return `${diffHours} ${t('notifications.hoursAgo')}`;
  } else if (diffDays < 7) {
    return `${diffDays} ${t('notifications.daysAgo')}`;
  }

  // Show date for older timestamps
  return date.toLocaleDateString('de-DE');
};
